export const paymentComponentMixin = {
    inheritAttrs: false,
    data() {
        return {
            values: null,
        };
    },
    props: {
        initialValues: {
            type: Object,
            default: () => ({}),
        },
        isEdit: {
            type: Boolean,
            default: false,
        },
    },
    mounted() {
        this.values = this.initialValues;
    },
    methods: {
        onEdit() {
            this.$emit('edit');
        },
        onCancel() {
            this.values = this.initialValues;
            this.$emit('cancel');
        },
        async onSave() {
            this.$emit('submit', this.values);
        },
    },
    watch: {
        initialValues(value, prevValue) {
            if (JSON.stringify(value) !== JSON.stringify(prevValue)) {
                this.values = value;
            }
        },
    },
};
